import React from 'react'
import { Img } from 'styles/GlobalStyle';
import { CartoonItem, WrapCartoon, WrapForm, WrapFormFields } from './Style';
import { useMediaQuery } from '@mui/material';

const AuthWithCartoon = (props) => {
    const { children, cartoon, cartoonSize } = props
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'), { noSsr: true })


    return (
        <>
            <WrapForm>
                <WrapFormFields>
                    {children}
                </WrapFormFields>
                {!isSmallScreen &&
                    <WrapCartoon>
                        <CartoonItem {...cartoonSize}>
                            <Img src={cartoon} />
                        </CartoonItem>
                    </WrapCartoon>}
            </WrapForm>
        </>
    )
}

export default AuthWithCartoon